<template>
  <div class="scroller-container pt-1">
    <slot name="prepend"/>
    <div ref="scroller" class="scroller pl-2">
      <slot name="scroller">
        <transition-group name="slide" duration="100" mode="out-in">
          <slot />
        </transition-group>
      </slot>
    </div>
    <Actions v-if="$vuetify.breakpoint.smAndUp" @top="scroll_top" @up="scroll_up" @down="scroll_down" class="scroller-actions" />
  </div>
</template>

<script>
import Actions from './Actions.vue'

export default {
  methods: {
    get_scroller() {
      return this.$refs.scroller
    },
    scroll_up() {
      let scroller = this.get_scroller()
      scroller.scrollTo({left: 0, top: scroller.scrollTop - this.scroll_bias, behavior: 'smooth'})
    },
    scroll_down() {
      let scroller = this.get_scroller()
      scroller.scrollTo({left: 0, top: scroller.scrollTop + this.scroll_bias, behavior: 'smooth'})
    },
    scroll_top() {
      let scroller = this.get_scroller()
      scroller.scrollTo({left: 0, top: 0, behavior: 'smooth'})
    },
    scrollBottom(){
      let scroller = this.get_scroller()
      scroller.scrollTo({left: 0, top: 999999999999, behavior: 'smooth'})
    }
  },
  computed: {
    scroll_bias(){
      let scroller = this.get_scroller()
      return scroller.clientHeight * 0.8
    },
  },
  components: {
    Actions
  }
}
</script>

<style>
.scroller-container {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.scroller {
  overflow-y: scroll;
  overflow-x: hidden;
  flex-grow: 1;
}

.scroller-actions {
  /* position: fixed; */
  /* width: 100%; */
  flex-shrink: 1;
  /* bottom: 0; */
  /* top: 100%; */
  /* left: 0;
  right: 0; */
}

.slide-enter-active {
  transition: all .1s ease-in-out;
  opacity: 0;
  transform: translateX(-40%);
  /* position: absolute; */
}

.slide-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-leave-active {
  transition: all .1s ease-in-out;
  opacity: 1;
  transform: translateX(0);
  position: absolute;
}

.slide-leave-to {
  opacity: 0;
  transform: translateX(-40%);
}

.slide-move {
  transition: all .1s ease-in-out;
  /* position: absolute; */
}
</style>